var map = {
	"./": [
		103,
		9
	],
	"./App": [
		104,
		9
	],
	"./App.js": [
		104,
		9
	],
	"./App.test": [
		217,
		9,
		0,
		2,
		33
	],
	"./App.test.js": [
		217,
		9,
		0,
		2,
		33
	],
	"./api": [
		38,
		9
	],
	"./api/": [
		38,
		9
	],
	"./api/about": [
		95,
		9
	],
	"./api/about.js": [
		95,
		9
	],
	"./api/agent": [
		188,
		9,
		34
	],
	"./api/agent.js": [
		188,
		9,
		34
	],
	"./api/config/host": [
		44,
		9
	],
	"./api/config/host.js": [
		44,
		9
	],
	"./api/contact": [
		189,
		9,
		35
	],
	"./api/contact.js": [
		189,
		9,
		35
	],
	"./api/index": [
		38,
		9
	],
	"./api/index.js": [
		38,
		9
	],
	"./api/product": [
		190,
		9,
		36
	],
	"./api/product.js": [
		190,
		9,
		36
	],
	"./assets/img/QRcode.png": [
		141,
		9
	],
	"./assets/img/aboutus.png": [
		317,
		9,
		69
	],
	"./assets/img/agentBg.png": [
		318,
		9,
		70
	],
	"./assets/img/attention.png": [
		363,
		9,
		71
	],
	"./assets/img/banner.png": [
		364,
		9,
		72
	],
	"./assets/img/corevalue.png": [
		365,
		9,
		73
	],
	"./assets/img/email-blue.png": [
		144,
		9
	],
	"./assets/img/email.png": [
		366,
		9,
		74
	],
	"./assets/img/email1.png": [
		319,
		9,
		75
	],
	"./assets/img/email_icon.png": [
		367,
		9,
		76
	],
	"./assets/img/enterprise.png": [
		320,
		9,
		77
	],
	"./assets/img/enterprise1.png": [
		368,
		9,
		78
	],
	"./assets/img/filings-icon.png": [
		147,
		9
	],
	"./assets/img/foot.png": [
		369,
		9,
		79
	],
	"./assets/img/freight.png": [
		293,
		9,
		80
	],
	"./assets/img/goodness1.png": [
		294,
		9,
		81
	],
	"./assets/img/goodness2.png": [
		295,
		9,
		82
	],
	"./assets/img/goodness3.png": [
		296,
		9,
		83
	],
	"./assets/img/goodness4.png": [
		297,
		9,
		84
	],
	"./assets/img/grow.png": [
		148,
		9
	],
	"./assets/img/innovate.png": [
		150,
		9
	],
	"./assets/img/join.png": [
		321,
		9,
		85
	],
	"./assets/img/location.png": [
		370,
		9,
		86
	],
	"./assets/img/logo.png": [
		90,
		9
	],
	"./assets/img/map.png": [
		322,
		9,
		87
	],
	"./assets/img/map1.png": [
		323,
		9,
		88
	],
	"./assets/img/mission.png": [
		324,
		9,
		89
	],
	"./assets/img/pain1.png": [
		298,
		9,
		90
	],
	"./assets/img/pain2.png": [
		299,
		9,
		91
	],
	"./assets/img/pain3.png": [
		300,
		9,
		92
	],
	"./assets/img/pain4.png": [
		301,
		9,
		93
	],
	"./assets/img/pain5.png": [
		302,
		9,
		94
	],
	"./assets/img/pain6.png": [
		303,
		9,
		95
	],
	"./assets/img/phone-blue.png": [
		145,
		9
	],
	"./assets/img/phone.png": [
		371,
		9,
		96
	],
	"./assets/img/phone1.png": [
		325,
		9,
		97
	],
	"./assets/img/platform.png": [
		326,
		9,
		98
	],
	"./assets/img/platform1.png": [
		372,
		9,
		99
	],
	"./assets/img/presentStatus.png": [
		304,
		9,
		100
	],
	"./assets/img/prices.png": [
		305,
		9,
		101
	],
	"./assets/img/procedure1.png": [
		356,
		9,
		102
	],
	"./assets/img/procedure2.png": [
		357,
		9,
		103
	],
	"./assets/img/procedure3.png": [
		358,
		9,
		104
	],
	"./assets/img/procedure4.png": [
		359,
		9,
		105
	],
	"./assets/img/productSwiper/1.png": [
		327,
		9,
		106
	],
	"./assets/img/productSwiper/2.png": [
		328,
		9,
		107
	],
	"./assets/img/productSwiper/3.png": [
		329,
		9,
		108
	],
	"./assets/img/productSwiper/4.png": [
		330,
		9,
		109
	],
	"./assets/img/productSwiper/5.png": [
		331,
		9,
		110
	],
	"./assets/img/productSwiper/6.png": [
		332,
		9,
		111
	],
	"./assets/img/progbg.png": [
		373,
		9,
		112
	],
	"./assets/img/programme1.png": [
		306,
		9,
		113
	],
	"./assets/img/programme2.png": [
		307,
		9,
		114
	],
	"./assets/img/programme3.png": [
		308,
		9,
		115
	],
	"./assets/img/programme4.png": [
		309,
		9,
		116
	],
	"./assets/img/programme5.png": [
		310,
		9,
		117
	],
	"./assets/img/programme6.png": [
		311,
		9,
		118
	],
	"./assets/img/serve.png": [
		374,
		9,
		119
	],
	"./assets/img/shadow.png": [
		375,
		9,
		120
	],
	"./assets/img/shui.png": [
		312,
		9,
		121
	],
	"./assets/img/site.png": [
		376,
		9,
		122
	],
	"./assets/img/spirit.png": [
		333,
		9,
		123
	],
	"./assets/img/system1.png": [
		290,
		9,
		124
	],
	"./assets/img/system2.png": [
		291,
		9,
		125
	],
	"./assets/img/system3.png": [
		292,
		9,
		126
	],
	"./assets/img/system4.png": [
		334,
		9,
		127
	],
	"./assets/img/target.png": [
		377,
		9,
		128
	],
	"./assets/img/up.png": [
		313,
		9,
		129
	],
	"./assets/img/upefficiency.png": [
		149,
		9
	],
	"./assets/img/values.png": [
		335,
		9,
		130
	],
	"./assets/img/vsion.png": [
		336,
		9,
		131
	],
	"./assets/img/warning.png": [
		314,
		9,
		132
	],
	"./assets/img/组 37989.png": [
		378,
		9,
		133
	],
	"./assets/style/components/foot.less": [
		40,
		7
	],
	"./assets/style/components/head.less": [
		25,
		7
	],
	"./assets/style/components/tab.less": [
		93,
		7
	],
	"./assets/style/pages/about/about.css": [
		289,
		7,
		42
	],
	"./assets/style/pages/about/cooperation.less": [
		337,
		7,
		45
	],
	"./assets/style/pages/about/enterprise.less": [
		338,
		7,
		46
	],
	"./assets/style/pages/about/honor.less": [
		339,
		7,
		47
	],
	"./assets/style/pages/about/joinus.less": [
		340,
		7,
		48
	],
	"./assets/style/pages/about/platform.less": [
		341,
		7,
		49
	],
	"./assets/style/pages/business/become.less": [
		342,
		7,
		50
	],
	"./assets/style/pages/business/bill.less": [
		343,
		7,
		51
	],
	"./assets/style/pages/business/photos.less": [
		344,
		7,
		52
	],
	"./assets/style/pages/business/procedure.less": [
		360,
		7,
		53
	],
	"./assets/style/pages/business/system.less": [
		345,
		7,
		54
	],
	"./assets/style/pages/contact/contactForm.less": [
		346,
		7,
		55
	],
	"./assets/style/pages/contact/contactUs.less": [
		347,
		7,
		56
	],
	"./assets/style/pages/contact/introduction.less": [
		348,
		7,
		57
	],
	"./assets/style/pages/contact/map.less": [
		349,
		7,
		58
	],
	"./assets/style/pages/index/coreProduct.less": [
		57,
		7
	],
	"./assets/style/pages/index/group.less": [
		59,
		7
	],
	"./assets/style/pages/index/newsBox.less": [
		32,
		7
	],
	"./assets/style/pages/index/newsInfo/newsInfo.less": [
		361,
		7,
		59
	],
	"./assets/style/pages/index/newslist/newsImg.less": [
		350,
		7,
		60
	],
	"./assets/style/pages/index/newslist/newsInformation.less": [
		362,
		7,
		61
	],
	"./assets/style/pages/index/newslist/newsList.less": [
		351,
		7,
		62
	],
	"./assets/style/pages/index/serveConcept.less": [
		75,
		7
	],
	"./assets/style/pages/index/target.less": [
		66,
		7
	],
	"./assets/style/pages/product/product.css": [
		352,
		7,
		43
	],
	"./assets/style/pages/product/products.less": [
		353,
		7,
		64
	],
	"./assets/style/pages/productCenter/productCenter.less": [
		354,
		7,
		63
	],
	"./assets/style/pages/solution/collection.less": [
		315,
		7,
		65
	],
	"./assets/style/pages/solution/freight.less": [
		316,
		7,
		66
	],
	"./assets/style/pages/solution/solution.css": [
		379,
		7,
		44
	],
	"./assets/style/pages/solution/tabs.less": [
		355,
		7,
		67
	],
	"./components/common/foot": [
		112,
		9
	],
	"./components/common/foot.jsx": [
		112,
		9
	],
	"./components/common/head": [
		109,
		9
	],
	"./components/common/head.jsx": [
		109,
		9
	],
	"./components/loading": [
		108,
		9
	],
	"./components/loading.jsx": [
		108,
		9
	],
	"./components/private/tab": [
		102,
		9
	],
	"./components/private/tab.jsx": [
		102,
		9
	],
	"./index": [
		103,
		9
	],
	"./index.css": [
		174,
		7
	],
	"./index.js": [
		103,
		9
	],
	"./pages/about/about": [
		218,
		9,
		7
	],
	"./pages/about/about.js": [
		218,
		9,
		7
	],
	"./pages/about/cooperation": [
		199,
		9,
		28
	],
	"./pages/about/cooperation.jsx": [
		199,
		9,
		28
	],
	"./pages/about/enterprise": [
		197,
		9,
		14
	],
	"./pages/about/enterprise.jsx": [
		197,
		9,
		14
	],
	"./pages/about/honor": [
		198,
		9,
		21
	],
	"./pages/about/honor.jsx": [
		198,
		9,
		21
	],
	"./pages/about/joinUs": [
		200,
		9,
		29
	],
	"./pages/about/joinUs.jsx": [
		200,
		9,
		29
	],
	"./pages/about/platform": [
		196,
		9,
		25
	],
	"./pages/about/platform.jsx": [
		196,
		9,
		25
	],
	"./pages/business/agent": [
		219,
		9,
		1,
		8
	],
	"./pages/business/agent.js": [
		219,
		9,
		1,
		8
	],
	"./pages/business/becomeagent": [
		201,
		9,
		26
	],
	"./pages/business/becomeagent.jsx": [
		201,
		9,
		26
	],
	"./pages/business/bill": [
		203,
		9,
		24
	],
	"./pages/business/bill.jsx": [
		203,
		9,
		24
	],
	"./pages/business/photos": [
		204,
		9,
		15
	],
	"./pages/business/photos.jsx": [
		204,
		9,
		15
	],
	"./pages/business/procedure": [
		214,
		9,
		1
	],
	"./pages/business/procedure.jsx": [
		214,
		9,
		1
	],
	"./pages/business/system": [
		202,
		9,
		18
	],
	"./pages/business/system.jsx": [
		202,
		9,
		18
	],
	"./pages/contact/Introduction": [
		205,
		9,
		27
	],
	"./pages/contact/Introduction.jsx": [
		205,
		9,
		27
	],
	"./pages/contact/contact": [
		220,
		9,
		6
	],
	"./pages/contact/contact.js": [
		220,
		9,
		6
	],
	"./pages/contact/contactForm": [
		208,
		9,
		16
	],
	"./pages/contact/contactForm.jsx": [
		208,
		9,
		16
	],
	"./pages/contact/contactUs": [
		206,
		9,
		22
	],
	"./pages/contact/contactUs.jsx": [
		206,
		9,
		22
	],
	"./pages/contact/map": [
		207,
		9,
		19
	],
	"./pages/contact/map.jsx": [
		207,
		9,
		19
	],
	"./pages/index": [
		84,
		9
	],
	"./pages/index/": [
		84,
		9
	],
	"./pages/index/coreProduct": [
		115,
		9
	],
	"./pages/index/coreProduct.jsx": [
		115,
		9
	],
	"./pages/index/group": [
		116,
		9
	],
	"./pages/index/group.jsx": [
		116,
		9
	],
	"./pages/index/index": [
		84,
		9
	],
	"./pages/index/index.js": [
		84,
		9
	],
	"./pages/index/newsBox": [
		117,
		9
	],
	"./pages/index/newsBox.jsx": [
		117,
		9
	],
	"./pages/index/newsInfo/newsInfo": [
		227,
		9,
		30
	],
	"./pages/index/newsInfo/newsInfo.js": [
		227,
		9,
		30
	],
	"./pages/index/newsList/newsImg": [
		209,
		9,
		31
	],
	"./pages/index/newsList/newsImg.jsx": [
		209,
		9,
		31
	],
	"./pages/index/newsList/newsInformation": [
		221,
		9,
		23,
		12
	],
	"./pages/index/newsList/newsInformation.js": [
		221,
		9,
		23,
		12
	],
	"./pages/index/newsList/newsList": [
		210,
		9,
		32
	],
	"./pages/index/newsList/newsList.jsx": [
		210,
		9,
		32
	],
	"./pages/index/serveConcept": [
		114,
		9
	],
	"./pages/index/serveConcept.jsx": [
		114,
		9
	],
	"./pages/index/target": [
		113,
		9
	],
	"./pages/index/target.jsx": [
		113,
		9
	],
	"./pages/product/product": [
		222,
		9,
		17
	],
	"./pages/product/product.js": [
		222,
		9,
		17
	],
	"./pages/product/products": [
		211,
		9,
		20
	],
	"./pages/product/products.jsx": [
		211,
		9,
		20
	],
	"./pages/productCenter/productCenter": [
		223,
		9,
		11
	],
	"./pages/productCenter/productCenter.js": [
		223,
		9,
		11
	],
	"./pages/productCenter/swiperPage": [
		212,
		9,
		13
	],
	"./pages/productCenter/swiperPage.jsx": [
		212,
		9,
		13
	],
	"./pages/solution/collection": [
		191,
		9,
		10
	],
	"./pages/solution/collection.jsx": [
		191,
		9,
		10
	],
	"./pages/solution/freight": [
		192,
		9,
		9
	],
	"./pages/solution/freight.jsx": [
		192,
		9,
		9
	],
	"./pages/solution/solution": [
		224,
		9,
		4
	],
	"./pages/solution/solution.js": [
		224,
		9,
		4
	],
	"./pages/solution/tabtitle": [
		213,
		9,
		5
	],
	"./pages/solution/tabtitle.jsx": [
		213,
		9,
		5
	],
	"./redux/solution/reducers": [
		110,
		9
	],
	"./redux/solution/reducers.js": [
		110,
		9
	],
	"./redux/store": [
		83,
		9
	],
	"./redux/store.js": [
		83,
		9
	],
	"./reportWebVitals": [
		118,
		9
	],
	"./reportWebVitals.js": [
		118,
		9
	],
	"./setupTests": [
		225,
		9,
		0,
		3,
		37
	],
	"./setupTests.js": [
		225,
		9,
		0,
		3,
		37
	],
	"./utils/LoadCmpt": [
		87,
		9
	],
	"./utils/LoadCmpt.js": [
		87,
		9
	],
	"./utils/rem": [
		143,
		7
	],
	"./utils/rem.js": [
		143,
		7
	],
	"./utils/routerData": [
		28,
		9
	],
	"./utils/routerData.js": [
		28,
		9
	],
	"./utils/storage": [
		55,
		9
	],
	"./utils/storage.js": [
		55,
		9
	],
	"./utils/utils": [
		53,
		9
	],
	"./utils/utils.js": [
		53,
		9
	],
	"./utils/verify": [
		226,
		9,
		38
	],
	"./utils/verify.js": [
		226,
		9,
		38
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 260;
module.exports = webpackAsyncContext;